import DOMPurify from 'dompurify';

// Saneador de HTML para el módulo de Aula Virtual. Es defensa en
// profundidad: la barrera real está en el backend (src/utils/sanitizeHtml.ts
// en api-gobe-smart-education, se aplica antes de guardar), pero acá se
// vuelve a limpiar tanto lo que el usuario pega en el editor como lo que se
// muestra con dangerouslySetInnerHTML, por si el HTML llegó de otra fuente
// (datos viejos, otra integración, etc).
const CONFIG = {
    ALLOWED_TAGS: [
        'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'strike',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'ul', 'ol', 'li', 'a', 'img', 'blockquote', 'pre', 'code',
        'span', 'div', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'hr', 'sub', 'sup'
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'width', 'height', 'style', 'class'],
    ALLOW_DATA_ATTR: false
};

const sanitizeHtml = (html) => DOMPurify.sanitize(html || '', CONFIG);

export default sanitizeHtml;
